import api from '../api/axios';

class WorkspacesService {
  async getWorkspaces() {
    const { data } = await api.get('/workspaces');
    return data;
  }
  async createWorkspace(data) {
    const { data: res } = await api.post('/workspaces', data);
    return res;
  }
  async updateWorkspace(id, data) {
    const { data: res } = await api.put(`/workspaces/${id}`, data);
    return res;
  }
  async deleteWorkspace(id) {
    const { data } = await api.delete(`/workspaces/${id}`);
    return data;
  }
}

export default new WorkspacesService();
